<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<p class="single" style="text-align: center;">
<br/>
	Diversion Books<br/>
	A Division of Diversion Publishing Corp.<br/>
	443 Park Avenue South, Suite 1008<br/>
	New York, NY 10016</p>
<p class="single" style="text-align: center;">
	www.DiversionBooks.com<br/>
<br/>
	Copyright © 2012 by Hook Slide, Inc.<br/>
<br/>
	All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="single" style="text-align: center;">
	For more information, email info@diversionbooks.com.</p>
<p class="single" style="text-align: center;">
	First Diversion Books edition October 2012.</p>
<p class="single" style="text-align: center;">
	ISBN: 978-1-938120-50-3</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap80289.vue?61c73d28